import React from 'react';
import { Select } from 'antd';
import _ from 'lodash';
import { getLoraDeviceLabel } from '@iso/constants/trackpacSensorTypes';

const { Option } = Select;

class BaseDeviceRenderer {
  renderOptions(deviceList, onChange) {
    throw new Error('renderOptions method must be implemented');
  }
}

class TrackpacDeviceRenderer extends BaseDeviceRenderer {
  renderOptions(deviceList, onChange) {
    const options = _.map(deviceList, (device, index) => (
      <Option key={index} value={JSON.stringify({ id: device.id, name: device.name })}>
        <div>{device.name}</div>
      </Option>
    ));

    return (
      <Select placeholder="Select a device" allowClear size="large" onChange={onChange}>
        {options}
      </Select>
    );
  }
}

class LoraAirAgriDeviceRenderer extends BaseDeviceRenderer {
  renderOptions(deviceList, onChange) {
    const options = _.map(deviceList, (device, index) => {
      // Show the model label AND the per-device identifier so admins can
      // tell otherwise-identical models apart (e.g. several GPS trackers).
      // `device.name` is whatever the unit is named upstream — sometimes a
      // friendly id (AA_0171, WCS-IOT-AIC-01), sometimes the raw DEV EUI.
      // Always surface it: "ModelLabel (identifier)".
      const modelLabel = getLoraDeviceLabel(device); // no EUI suffix
      const identifier = device.name;
      let label;
      if (identifier && modelLabel && identifier !== modelLabel) {
        label = `${modelLabel} (${identifier})`;
      } else {
        label = identifier || modelLabel;
      }
      return (
        <Option key={index} value={JSON.stringify({ id: device.id, name: device.name })}>
          <div>{label}</div>
        </Option>
      );
    });

    return (
      <Select placeholder="Select a device" allowClear size="large" onChange={onChange}>
        {options}
      </Select>
    );
  }
}

class TraccarDeviceRenderer extends BaseDeviceRenderer {
  renderOptions(deviceList, onChange) {
    const options = _.map(deviceList, (device, index) => (
      <Option key={index} value={JSON.stringify({ id: device.id, name: device.name })}>
        <div>{device.name}</div>
      </Option>
    ));

    return (
      <Select placeholder="Select a device" allowClear size="large" onChange={onChange}>
        {options}
      </Select>
    );
  }
}

class RFTechnologyDeviceRenderer extends BaseDeviceRenderer {
  renderOptions(deviceList, onChange) {
    const options = _.map(deviceList, (device, index) => (
      <Option key={index} value={device}>
        <div>{device}</div>
      </Option>
    ));

    return (
      <Select placeholder="Select a device" allowClear size="large" onChange={onChange}>
        {options}
      </Select>
    );
  }
}

class KineticSolutionsDeviceRenderer extends BaseDeviceRenderer {
  renderOptions(deviceList, onChange) {
    const options = _.map(deviceList, (device, index) => (
      <Option key={index} value={device}>
        <div>{device}</div>
      </Option>
    ));

    return (
      <Select placeholder="Select a device" allowClear size="large" onChange={onChange}>
        {options}
      </Select>
    );
  }
}

export class DeviceRenderFactory {
  static createRenderer(supplier) {
    if (!supplier) {
      throw new Error('Supplier is required');
    }

    switch (supplier) {
      case 'Trackpac':
        return new TrackpacDeviceRenderer();
      case 'Lora AirAgri':
        return new LoraAirAgriDeviceRenderer();
      case 'RF Technology':
        return new RFTechnologyDeviceRenderer();
      case 'Traccar AirAgri':
        return new TraccarDeviceRenderer();
      case 'Kinetic Solutions':
        return new KineticSolutionsDeviceRenderer();
      default:
        throw new Error(`Unsupported supplier for device rendering: ${supplier}`);
    }
  }
}
